<template>
  <div class="page-project-column-text-block">
    <div v-if="title && title !== ''" v-html="title" />
    <div v-if="text && text !== ''" v-html="text" />
  </div>
</template>

<script>
export default {
  name: 'PagesProjectColumnTextBlock',
}
</script>

<script setup>
const props = defineProps({
  title: String,
  text: String
})
</script>

<style lang="scss">
@import './style.scss';
</style>
